import { useState } from 'react';

import { ScoreType } from '@/domain/impact/impact.entity';
import { ImpactQuestionContext } from '@/ui/pages/app/components/quiz-panel/ImpactQuestionContext';
import { QuizPanel } from '@/ui/pages/app/components/quiz-panel/QuizPanel';

import { getTourCo2QuizFormData } from '../utils/tour-co2-form-data';
import { envTourGeneralQuizLayout } from '../utils/tour-general-env-quiz-layout';
import { essTourGeneralQuizLayout } from '../utils/tour-general-ess-quiz-layout';
import { QuizPanelCustomTourCo2 } from './QuizPanelCustomTourCo2';

export function ProjectTourQuizPanel({
  projectId,
  selectedScoreType,
  selectedSubType,
  isQuizLayoutDisplayed,
  setIsQuizLayoutDisplayed,
}: {
  projectId: number;
  selectedScoreType: ScoreType;
  selectedSubType: string;
  isQuizLayoutDisplayed: boolean;
  setIsQuizLayoutDisplayed: React.Dispatch<React.SetStateAction<boolean>>;
}) {
  const [panelOpen, setPanelOpen] = useState(false);
  const [hideCompleted, setHideCompleted] = useState(false);

  const co2FormData = getTourCo2QuizFormData(selectedSubType);
  const envQuizLayout = envTourGeneralQuizLayout;
  const essQuizLayout = essTourGeneralQuizLayout;

  return (
    <ImpactQuestionContext.Provider
      value={{
        panelOpen,
        hideCompleted,
        setHideCompleted,
        setPanelOpen,
      }}
    >
      {isQuizLayoutDisplayed && (
        <>
          {selectedScoreType === 'co2' ? (
            <QuizPanelCustomTourCo2
              projectId={projectId}
              quizSubType={selectedSubType}
              setIsQuizLayoutDisplayed={setIsQuizLayoutDisplayed}
            />
          ) : (
            <QuizPanel
              projectId={projectId}
              quizScoreType={selectedScoreType}
              quizSubType={selectedSubType}
              sector={''}
              externalExistingInvitations={[]}
              onSubmitInvite={() => {}}
              setIsQuizLayoutDisplayed={setIsQuizLayoutDisplayed}
              co2FormData={co2FormData}
              co2ExternalFormData={undefined}
              envQuizLayout={envQuizLayout}
              essQuizLayout={essQuizLayout}
              enableExternal={false}
              enableExternalPublic={false}
              enableExternalAnswsersView={false}
            />
          )}
        </>
      )}
    </ImpactQuestionContext.Provider>
  );
}
